import { render, staticRenderFns } from "./BookingsOverview.vue?vue&type=template&id=48c84e66"
import script from "./BookingsOverview.vue?vue&type=script&lang=js"
export * from "./BookingsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports